import Popper from "@mui/material/Popper/Popper"
import { TabDetails } from "../../../shared/UI/Tab"
import { BookingZIndexLayers } from "../Shared/enums"
import { MobileOrientationPopOverOptions } from "../consts"
import { BookingAvailabilityItem } from "../types"


interface PopoverWrapper {
  isMobile: boolean
  popoverPosition: any
  popoverWidth: number
  isOwnBooking: boolean
  deskLabel: string
  availability: BookingAvailabilityItem
  date: Date | string
  showDate: boolean
  tabSelectionProps: TabDetails[]
  getSubmitLabel: () => string
  getSubmitDisabledState: () => boolean
  onButtonClick: () => void
  onClickCallback: () => void
  setSelectedTab: (index: number) => void
}

interface PopperProps {
  open: boolean
  anchorEl: SVGElement | undefined
  placement: any | undefined
  style: object
  popoverProps: PopoverWrapper
}

const {
  BOOKING_MOBILE_FLOORPLAN_VIEW_FEATURE_POPOVER
} = BookingZIndexLayers

const PopoverWrapper = (popoverFixed: boolean) => (WrappedComponent: any) => {
  const WithPopoverWrapper = function (props: PopperProps) { 

    const { popoverPosition } = props.popoverProps
    const mobilePortaitCode = MobileOrientationPopOverOptions.MOBILE_PORTRAIT
    const mobilePortraitIsActive = popoverPosition === mobilePortaitCode
    const { popoverProps, ...otherProps } = props

    return popoverFixed ? 
    (
      <div 
        style={{
          position: 'fixed',
          zIndex: BOOKING_MOBILE_FLOORPLAN_VIEW_FEATURE_POPOVER,
          ...(mobilePortraitIsActive ? {
            bottom: '-2px',
            left: '0px',
            width: `100%`,
          } : {
            bottom: '-2px',
            right: '-1px',
            height: `calc(100% - 70px)`,
            width: `50%`,
          })
        }}
      >
        <WrappedComponent {...props?.popoverProps} />
      </div>
    ) : (
      <Popper
        {...otherProps}
      >
        <WrappedComponent {...props?.popoverProps} />
      </Popper>
    )
  }
  
  WithPopoverWrapper.displayName = `PopoverWrapper(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

  return WithPopoverWrapper

}


export default PopoverWrapper
